/**
 * Asynchronously loads the component for ErrorLogs
 */
import { lazyLoad } from 'utils/loadable';

export const ErrorLogs = lazyLoad(() => import('./index'));
